import React, { Component } from "react";
import { Layout, Menu, Icon, Button, Divider } from "antd";
import { removeToken } from "../utils/LoginManager";
import { withRouter, Link } from "react-router-dom";
import { getUsuarioToken, getTemPermissao } from "../utils/LoginManager";
import Colors from '../utils/Colors';

const { Sider } = Layout;
const { Item, SubMenu } = Menu;

class SideMenu extends Component {
  rootSubmenuKeys = ['cadastros', 'pedidos', 'configuracoes'];

  state = {
    openKeys: [],
    collapsed: false,
  };

  componentDidMount() {
    const usuario = getUsuarioToken();
    this.setState({ usuario });
  }

  onOpenChange = (openKeys) => {
    const latestOpenKey = openKeys.find(key => this.state.openKeys.indexOf(key) === -1);
    if (this.rootSubmenuKeys.indexOf(latestOpenKey) === -1) {
      this.setState({ openKeys });
    } else {
      this.setState({
        openKeys: latestOpenKey ? [latestOpenKey] : [],
      });
    }
  }

  sair = () => {
    removeToken();
    this.props.history.push("/login");
  };

  toggleCollapsed = () => {
    this.setState({
      collapsed: !this.state.collapsed,
    });
  }

  render() {

    return (
      <div style={{ width: this.state.collapsed ? 80 : 200, background: '#10734a' }}>
        <Sider breakpoint="md" collapsedWidth="0" style={{ background: '#10734a', width: this.state.collapsed ? 80 : 200 }}>
          <div className="side-menu-logo" style={{ height: 55, marginTop: 5, }}>
            {process.env.NODE_ENV === 'development' && !this.state.collapsed ? (
              <h1>SIGA PRO</h1>
            ) : !this.state.collapsed ? (
              <h1>P7Vendas</h1>
            ) : ''}
          </div>
        </Sider>
        <div style={{ background: '#10734a' }}>

          <Menu
            mode="vertical-left"
            theme="dark"
            openKeys={this.state.openKeys}
            onOpenChange={this.onOpenChange}
            style={{ background: '#10734a' }}
            inlineCollapsed={this.state.collapsed}
          >
            <Item>
              <Link to="/">
                <Icon type="dashboard" />
                <span>Início</span>
              </Link>
            </Item>

            <SubMenu key="lancamentos" title={<span><Icon type="file-text" /><span>Lançamentos</span></span>}>
              {getTemPermissao('PedidosPage', 'cons') ? (
                <Item style={{ marginBottom: 0 }}>
                  <Link to="/pedidos">
                    <Icon type="form" />
                    <span>Pedidos Venda</span>
                  </Link>
                </Item>
              ) : null}

              {getTemPermissao('EntregasPage', 'cons') || getTemPermissao('AtividadesPage', 'cons') || getTemPermissao('ContagemEstoquePage', 'cons') ? (
                <Divider style={{ marginTop: 0, marginBottom: 0, backgroundColor: Colors.primaryLight }} />
              ) : null}

              {getTemPermissao('EntregasPage', 'cons') ? (
                <Item style={{ marginTop: 0, marginBottom: 0 }}>
                  <Link to="/entregas">
                    <Icon type="car" />
                    <span>Controle de Entregas</span>
                  </Link>
                </Item>
              ) : null}

              {getTemPermissao('AtividadesPage', 'cons') ? (
                <Item style={{ marginTop: 0, marginBottom: 0 }}>
                  <Link to="/atividades">
                    <Icon type="tags" />
                    <span>Atividades dos Vendedores</span>
                  </Link>
                </Item>
              ) : null}

              {getTemPermissao('ContagemEstoquePage', 'cons') ? (
                <Item style={{ marginTop: 0, marginBottom: 0 }}>
                  <Link to="/contagemEstoque">
                    <Icon type="barcode" />
                    <span>Contagem Estoque</span>
                  </Link>
                </Item>
              ) : null}


              {getTemPermissao('OrdemProducaoPage', 'cons') || getTemPermissao('MonitorProducaoPage', 'cons') || getTemPermissao('EstoqueProducaoPage', 'cons') ? (
                <Divider style={{ marginTop: 0, marginBottom: 0, backgroundColor: Colors.primaryLight }} />
              ) : null}

              {getTemPermissao('OrdemProducaoPage', 'cons') ? (
                <Item style={{ marginTop: 0, marginBottom: 0 }}>
                  <Link to="/ordemProducao">
                    <Icon type="rocket" />
                    <span>Ordens de Produção</span>
                  </Link>
                </Item>
              ) : null}

              {getTemPermissao('MonitorProducaoPage', 'cons') ? (
                <Item style={{ marginTop: 0, marginBottom: 0 }}>
                  <Link to="/monitorProducao">
                    <Icon type="check-square-o" />
                    <span>Monitor da Produção</span>
                  </Link>
                </Item>
              ) : null}

              {getTemPermissao('EstoqueProducaoPage', 'cons') ? (
                <Item style={{ marginTop: 0, marginBottom: 0 }}>
                  <Link to="/estoqueProducao">
                    <Icon type="database" />
                    <span>Estoque da Produção</span>
                  </Link>
                </Item>
              ) : null}

              {getTemPermissao('AnaliseProducaoPage', 'cons') ? (
                <Divider style={{ marginTop: 0, marginBottom: 0, backgroundColor: Colors.primaryLight }} />
              ) : null}

              {getTemPermissao('AnaliseProducaoPage', 'cons') ? (
                <Item style={{ marginTop: 0, marginBottom: 0 }}>
                  <Link to="/analiseProducao">
                    <Icon type="medicine-box" />
                    <span>Análise Laboratorial</span>
                  </Link>
                </Item>
              ) : null}

            </SubMenu>

            <SubMenu key="relatorios" title={<span><Icon type="area-chart" /><span>Relatórios</span></span>}>
              <SubMenu style={{ marginTop: 0, marginBottom: 0 }} key="relVendas" title={<span>Vendas</span>}>
                {getTemPermissao('ProdutosVendidosPage', 'cons') ? (
                  <Menu.Item style={{ marginTop: 0, marginBottom: 0 }} key="ProdutosVendidosPage"><Link to="/produtosVendidos"><span>Produtos Vendidos</span></Link></Menu.Item>
                ) : null}
                {getTemPermissao('CarteiraClientesPage', 'cons') ? (
                  <Menu.Item style={{ marginTop: 0, marginBottom: 0 }} key="CarteiraClientesPage"><Link to="/carteiraClientes"><span>Carteira de Clientes</span></Link></Menu.Item>
                ) : null}
                {getTemPermissao('VendasVendedoresPage', 'cons') ? (
                  <Menu.Item style={{ marginTop: 0, marginBottom: 0 }} key="VendasVendedoresPage"><Link to="/vendasVendedores"><span>Vendas por Vendedores</span></Link></Menu.Item>
                ) : null}
                {getTemPermissao('VendasGradePage', 'cons') ? (
                  <Menu.Item style={{ marginTop: 0, marginBottom: 0 }} key="VendasGradePage"><Link to="/vendasGrade"><span>Vendas por Grade</span></Link></Menu.Item>
                ) : null}
              </SubMenu>
              {getTemPermissao('ContasAReceberPage', 'cons') ? (
                <Menu.Item style={{ marginTop: 0, marginBottom: 0 }} key="ContasAReceberPage"><Link to="/contasAReceberPage"><span>Contas À Receber</span></Link></Menu.Item>
              ) : null}
              {getTemPermissao('AtividadesVendedoresPage', 'cons') ? (
                <Menu.Item style={{ marginTop: 0, marginBottom: 0 }} key="AtividadesVendedoresPage"><Link to="/atividadesVendedores"><span>Atividades por Vendedores</span></Link></Menu.Item>
              ) : null}
            </SubMenu>

            <SubMenu key="cadastros" title={<span><Icon type="database" /><span>Cadastros</span></span>}>
              {getTemPermissao('ClientesPage', 'cons') ? (
                <Menu.Item style={{ marginTop: 0, marginBottom: 0 }} key="ClientesPage"><Link to="/clientes"><span>Clientes</span></Link></Menu.Item>
              ) : null}
              <SubMenu key="cadProdutos" title={<span>Produtos</span>}>
                {getTemPermissao('ProdutosPage', 'cons') ? (
                  <Menu.Item style={{ marginTop: 0, marginBottom: 0 }} key="ProdutosPage"><Link to="/produtos"><span>Produtos</span></Link></Menu.Item>
                ) : null}
                {getTemPermissao('GruposPage', 'cons') ? (
                  <Menu.Item style={{ marginTop: 0, marginBottom: 0 }} key="GruposPage"><Link to="/grupos"><span>Grupos</span></Link></Menu.Item>
                ) : null}
                {getTemPermissao('MarcasPage', 'cons') ? (
                  <Menu.Item style={{ marginTop: 0, marginBottom: 0 }} key="MarcasPage"><Link to="/marcas"><span>Marcas</span></Link></Menu.Item>
                ) : null}
                {getTemPermissao('MedidasPage', 'cons') ? (
                  <Menu.Item style={{ marginTop: 0, marginBottom: 0 }} key="MedidasPage"><Link to="/medidas"><span>Medidas</span></Link></Menu.Item>
                ) : null}
                {getTemPermissao('GradesTipoPage', 'cons') ? (
                  <Menu.Item style={{ marginTop: 0, marginBottom: 0 }} key="GradesTipoPage"><Link to="/gradesTipo"><span>Tipos de Grades</span></Link></Menu.Item>
                ) : null}
                {getTemPermissao('GradesTamanhoPage', 'cons') ? (
                  <Menu.Item style={{ marginTop: 0, marginBottom: 0 }} key="GradesTamanhoPage"><Link to="/gradesTamanho"><span>Tamanhos de Grades</span></Link></Menu.Item>
                ) : null}
              </SubMenu>
              <SubMenu key="cadFinanc" title={<span>Financeiro</span>}>
                {getTemPermissao('CondPagtosPage', 'cons') ? (
                  <Menu.Item style={{ marginTop: 0, marginBottom: 0 }} key="CondPagtosPage"><Link to="/condPagtos"><span>Cond. Pagtos</span></Link></Menu.Item>
                ) : null}
                {getTemPermissao('EmpresaMetasPage', 'cons') ? (
                  <Menu.Item style={{ marginTop: 0, marginBottom: 0 }} key="EmpresaMetasPage"><Link to="/empresaMetas"><span>Metas da Empresa Geral</span></Link></Menu.Item>
                ) : null}
                {getTemPermissao('UsuariosMetasPage', 'cons') ? (
                  <Menu.Item style={{ marginTop: 0, marginBottom: 0 }} key="UsuariosMetasPage"><Link to="/vendedoresMetas"><span>Metas dos Vendedores</span></Link></Menu.Item>
                ) : null}
                {getTemPermissao('TabelaDescontosPage', 'cons') ? (
                  <Menu.Item style={{ marginTop: 0, marginBottom: 0 }} key="TabelaDescontosPage"><Link to="/tabelaDescontos"><span>Tabela de Descontos</span></Link></Menu.Item>
                ) : null}
              </SubMenu>
              <SubMenu key="cadProducao" title={<span>Produção</span>}>
                {getTemPermissao('LinhasProducaoPage', 'cons') ? (
                  <Menu.Item style={{ marginTop: 0, marginBottom: 0 }} key="LinhasProducaoPage"><Link to="/linhasProducao"><span>Linha de Produção</span></Link></Menu.Item>
                ) : null}
                {getTemPermissao('StatusProducaoPage', 'cons') ? (
                  <Menu.Item style={{ marginTop: 0, marginBottom: 0 }} key="StatusProducaoPage"><Link to="/statusProducao"><span>Status da Produção</span></Link></Menu.Item>
                ) : null}
                {getTemPermissao('CategoriaAnaliseProducaoPage', 'cons') ? (
                  <Menu.Item style={{ marginTop: 0, marginBottom: 0 }} key="CategoriaAnaliseProducaoPage"><Link to="/categoriaAnaliseProducao"><span>Categoria da Análise de Produção</span></Link></Menu.Item>
                ) : null}
                {getTemPermissao('TiposAnalisesPage', 'cons') ? (
                  <Menu.Item style={{ marginTop: 0, marginBottom: 0 }} key="TiposAnalisesPage"><Link to="/tiposAnalises"><span>Tipos de Análise</span></Link></Menu.Item>
                ) : null}
                {getTemPermissao('ProdutosTiposAnalisesPage', 'cons') ? (
                  <Menu.Item style={{ marginTop: 0, marginBottom: 0 }} key="ProdutosTiposAnalisesPage"><Link to="/produtosTiposAnalises"><span>Produtos / Tipos de Análise</span></Link></Menu.Item>
                ) : null}
              </SubMenu>
              <SubMenu key="cadVendas" title={<span>Vendas</span>}>
                {getTemPermissao('StatusVendasMetasPage', 'cons') ? (
                  <Menu.Item style={{ marginTop: 0, marginBottom: 0 }} key="StatusVendasMetasPage"><Link to="/statusVendas"><span>Status da Venda</span></Link></Menu.Item>
                ) : null}
                {getTemPermissao('StatusEntregasPage', 'cons') ? (
                  <Menu.Item style={{ marginTop: 0, marginBottom: 0 }} key="StatusEntregasPage"><Link to="/statusEntregas"><span>Status da Entrega</span></Link></Menu.Item>
                ) : null}
                {getTemPermissao('TabelaFretesPage', 'cons') ? (
                  <Menu.Item style={{ marginTop: 0, marginBottom: 0 }} key="TabelaFretesPage"><Link to="/tabelaFretes"><span>Tabela Frete</span></Link></Menu.Item>
                ) : null}
                {getTemPermissao('UsuariosSupervisoresPage', 'cons') ? (
                  <Menu.Item style={{ marginTop: 0, marginBottom: 0 }} key="UsuariosSupervisoresPage"><Link to="/vendedoresSupervisores"><span>Supervisores de Vendas</span></Link></Menu.Item>
                ) : null}
                {getTemPermissao('UsuariosProdutosPage', 'cons') ? (
                  <Menu.Item style={{ marginTop: 0, marginBottom: 0 }} key="UsuariosProdutosPage"><Link to="/vendedoresProdutos"><span>Produtos dos Vendedores</span></Link></Menu.Item>
                ) : null}
              </SubMenu>
              <SubMenu key="cadDescontos" title={<span>Descontos</span>}>
                <Menu.Item style={{ marginTop: 0, marginBottom: 0 }} key="TabelaFlexPage"><Link to="/tableFlex"><span>Tabela Flex</span></Link></Menu.Item>
                <Menu.Item style={{ marginTop: 0, marginBottom: 0 }} key="precosRegiaoPage"><Link to="/precosRegiao"><span>Preços por Região</span></Link></Menu.Item>
                <Menu.Item style={{ marginTop: 0, marginBottom: 0 }} key="PromocaoProdutoPage"><Link to="/promocaoProduto"><span>Promoção de Produtos</span></Link></Menu.Item>
                <Menu.Item style={{ marginTop: 0, marginBottom: 0 }} key="TabelaEspecialPage"><Link to="/tabelaEspecialCliente"><span>Tabela Especial por Cliente</span></Link></Menu.Item>
                <Menu.Item style={{ marginTop: 0, marginBottom: 0 }} key="ProdutosClientePage"><Link to="/produtosCliente"><span>Produtos por Cliente</span></Link></Menu.Item>
              </SubMenu>
            </SubMenu>

            <SubMenu key="configuracoes" title={<span><Icon type="setting" /><span>Configurações</span></span>}>
              {this.state.usuario && !this.state.usuario.usu_tipo ? (
                <Menu.Item style={{ marginTop: 0, marginBottom: 0 }} key="EmpresasPage"><Link to="/empresas"><span>Empresas</span></Link></Menu.Item>
              ) : null}
              {this.state.usuario && !this.state.usuario.usu_tipo ? (
                <Menu.Item style={{ marginTop: 0, marginBottom: 0 }} key="UsuariosPage"><Link to="/usuarios"><span>Usuários</span></Link></Menu.Item>
              ) : null}
              {getTemPermissao('PermissoesPage', 'cons') ? (
                <Menu.Item style={{ marginTop: 0, marginBottom: 0 }} key="PermissoesPage"><Link to="/permissoes"><span>Permissões dos Usuários</span></Link></Menu.Item>
              ) : null}
              {getTemPermissao('GruposUsuariosPage', 'cons') ? (
                <Menu.Item style={{ marginTop: 0, marginBottom: 0 }} key="GruposUsuariosPage"><Link to="/gruposUsuarios"><span>Grupos dos Usuários</span></Link></Menu.Item>
              ) : null}
              {this.state.usuario && !this.state.usuario.usu_tipo ? (
                <Menu.Item style={{ marginTop: 0, marginBottom: 0 }} key="LogPage"><Link to="/log"><span>Log</span></Link></Menu.Item>
              ) : null}
            </SubMenu>

            <Item>
              <Link to="/alterarSenha">
                <Icon type="key" />
                <span>Alterar Senha</span>
              </Link>
            </Item>

            <Item>
              <a onClick={this.sair}>
                <Icon type="logout" />
                <span>Sair</span>
              </a>
            </Item>
          </Menu>

          <div style={{ paddingLeft: 5, paddingRight: 3, paddingTop: 10 }}>
            <div style={{ height: 1, marginBottom: 20, width: "100%", borderWidth: 1, backgroundColor: Colors.dividerLight }} />
            <Icon type="user" className="iconeLayout" style={{ color: Colors.textDisabledLight }} />
            <span style={{ color: Colors.textDisabledLight, marginLeft: 5 }}>{this.state.usuario ? this.state.usuario.usu_nome : ''} </span>
          </div>


          <div style={{ textAlign: 'center', margin: 10, marginTop: 30 }}>
            <Button type="ghost" htmlType="button" onClick={this.toggleCollapsed} style={{ width: "100%" }}>
              <Icon type={this.state.collapsed ? 'double-right' : 'double-left'} />
            </Button>
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(SideMenu);



// WEBPACK FOOTER //
// ./src/layouts/SideMenu.js